// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


//let url = 'http://34.148.196.136:4000/';
//let url = 'http://localhost:4000/';
//let url = 'https://www.hayti.com/';
let url = 'https://dev.aws.hayti.com/';

export const environment = {
  production: false,
  APIBaseURL: url,
  APIBaseImgUrl: url,
  APIBaseFileUrl: url + "uploads/files/",
  APIEcabinetDocUrl: url + 'ecabinet/',
  BaseURL: 'https://dev.aws.hayti.com',
  BaseAPIURL: 'https://v1api.dev.aws.hayti.com',
//BaseURL: 'http://localhost',
//BaseAPIURL: 'http://localhost:4000',
  
  
  // BaseURL: window.location.origin,
  locationUrl: '',
 
  recaptcha: {
    siteKey: '6LfKNi0cAAAAACeYwFRY9_d_qjGhpiwYUo5gNW5-',
  },
  
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
